// extracted by mini-css-extract-plugin
export default {"modal":"face-capture-screen_modal__HT9mP","modalImage":"face-capture-screen_modalImage__IJklO"};